/* eslint-disable */
// URL list
import CONFIG from '../../config'

// Required for multi-pages website
import router from './Router'

// Core
import CoreScroll from '../mixins/core-scroll'

// Pages
import Page404 from '../components/page-404'
import PagePresale from '../components/page-presale'
import PagePlatform from '../components/page-platform'
import PageHome from '../components/page-home'
import PageSample from '../components/page-sample'
import PageTeam from '../components/page-team'
import pageToken from '../components/page-token'

// Components
import AppHeader from '../components/app-header'
import AppLoader from '../components/app-loader'
import AppPageTransition from '../components/app-page-transition'
import AppPopinEmail from '../components/app-popin-email'
import AppSoundManager from '../components/app-sound-manager'

// Utils
import Gateway from './Gateway'
import Support from '../utils/global/Support'
import * as Random from '../utils/Random'
import * as String from '../utils/String'

const support = new Support()

export default {
    router,

    name: 'app',

    watch: {
        $route: '_onRouteChange',
        routingStep: 'onRoutingStepChange'
    },

    mixins: [
        CoreScroll
    ],

    components: {
        // Pages
        Page404,
        PagePresale,
        PagePlatform,
        PageHome,
        PageSample,
        PageTeam,
        pageToken,

        // Components
        AppHeader,
        AppLoader,
        AppPageTransition,
        AppPopinEmail,
        AppSoundManager
    },

    data() {
        return {
            CONFIG,

            router,

            width: 0,
            height: 0,

            componentId: null,
            _content: null,
            content: null,
            params: null,

            isFirstLoading: true,
            isFirstLoaded: false,

            isFirstRouting: true,
            routingStep: 0,

            isMuted: false,

            isMenuOpened: false,

            pageHeight: 0,
            pageHeightBackup: 0,

            currScrollTop: 0,

            // Routes
            urlHistory: [],

            // Bind with other components, don't change his label
            isTouch: support.touch,
            isIOS: support.ios
        }
    },

    created() {
        // console.log('%cPractical VR (ICO)%c\nby Immersive Garden (%chttps://immersive-g.com%c)', 'color: #1f56fb; font-size: x-large; font-weight: bold;', 'color: #aaaaaa; font-size: 12px', 'color: #111111; font-size: 12px', 'color: #aaaaaa; font-size: 12px')
        this.eventHub.$on('page:scroll-to', this.scrollTo)
        this.eventHub.$on('page:set-height', this.onSetPageHeight)
        this.eventHub.$on('application:create-cookie', this.createCookie)
        this.eventHub.$on('application:read-cookie', this.readCookie)
        this.eventHub.$on('application:hide-loader', this.hideLoader)

        window.addEventListener('resize', this.onResize)

        document.addEventListener('keydown', this.onKeydown)

        // Set currentUrl
        this.currentURL = this.$root.$route.path

        // Set lang
        let lang = this.$route.params.lang

        // No lang
        if (typeof lang === 'undefined' || ['fr', 'en'].indexOf(lang) === -1) {
            lang = navigator.language || navigator.userLanguage
            lang = lang.substring(0, 2).toLowerCase()

            if (['fr', 'en'].indexOf(lang) === -1) lang = 'en'
        }

        this.lang = lang

        // Set variables
        this.scrollTop = 0
        this.currScrollTop = 0

        // Get all JSON
        Promise.all(Object.keys(CONFIG.json).map(key => {
            const json = CONFIG.json[key]
            return this._getJSON(json.url)
        })).then(response => {
            this._content = {}
            response.forEach(res => {
                this._content[res.pathname] = res
            })

            this.content = this._content
        })

        // Run page
        this._onRouteChange(this.$route)

        // Initialize viewportUnitsBuggyfill
        // viewportUnitsBuggyfill.init()
        //
        // // Also hook viewportUnitsBuggyfill to resize event (if it was initialized)
        // if (document.getElementById('patched-viewport')) {
        //     window.addEventListener('resize', viewportUnitsBuggyfill.refresh, true)
        // }
    },

    mounted() {
        this.container = this.$el.querySelector('.js-container')

        this.onResize()
        this.onEnterFrame()
    },

    methods: {
        // Loader
        toggleFirstLoading(isFirstLoading) {
            this.isFirstLoading = isFirstLoading || !this.isFirstLoading

            if (!this.isFirstLoading) {
                this.isFirstLoaded = true
            }
        },

        hideLoader() {
            this.toggleFirstLoading()
        },

        // Window
        onResize() {
            this.width  = window.innerWidth
            this.height = window.innerHeight

            this.eventHub.$emit('window:resize')
        },

        onScroll(y) {
            if (this.routingStep === 0 && !this.isMenuOpened) {
                this.scrollTop = y
            }
        },

        scrollTo(value) {
            document.documentElement.scrollTop = value || 0
            document.body.parentNode.scrollTop = value || 0
            document.body.scrollTop = value || 0

            this.currScrollTop = this.scrollTop = 0
        },

        onSetPageHeight(height) {
            this.pageHeight = height
            this.pageHeightBackup = this.pageHeight
        },

        // Keyboard
        onKeydown(event) {
            this.eventHub.$emit('keyboard:keydown', event)
        },

        // Frames
        onEnterFrame() {
            this.eventHub.$emit('application:onEnterFrame')
            window.requestAnimationFrame(this.onEnterFrame)

            this.currScrollTop += (this.scrollTop - this.currScrollTop) * 0.1
            // Round up / down the scroll value
            this.currScrollTop = Math.round(this.currScrollTop)

            if (this.currScrollTop % 1 >= 0.95 || this.currScrollTop % 1 <= 0.05) {
              this.currScrollTop = Math.round(this.currScrollTop)
            }

            if (this.currScrollTop <= 0.01) this.currScrollTop = 0
            
            if (this.$route.name !== 'page-home' && this.$route.name !== 'page-home-slide' && this.width > 770 && !this.isTouch) {
                this.container.style.transform = `translateY(${-this.currScrollTop}px) translateZ(0)`
            } else {
                this.container.style.transform = `translateY(0) translateZ(0)`
            }
        },

        // Routes
        changePage(url = '/') {
            this.router.push(url)
        },

        _onRouteChange(to, from) /* (to, from) */ {
            if (this.componentId !== to.meta.component || this.componentId === this.CONFIG.pages.homeSlide.name) {
                // console.group('Page')
                // console.log(`%cURL:%c ${to.path}`, 'color: #4f4f4f;', 'color: #e62932;')
                // console.log(`%cComponent:%c ${to.meta.component}`, 'color: #4f4f4f;', 'color: #e62932;')
                // console.groupEnd()

                this.eventHub.$emit('app-sound-manager:mute', 'loop')

                if (this.componentId === to.meta.component) {
                    this._updatePageMeta(to)
                }

                if (this.componentId !== to.meta.component) {
                    this.pageTransition()

                    setTimeout(() => {
                        this._updatePageMeta(to)

                        this.$root.isFirstLoaded = false
                        this.componentId = to.meta.component
                        this.params = to.params

                        this.currentURL = to.path

                        this.urlHistory.push(JSON.parse(JSON.stringify(this.currentURL)))

                        this.eventHub.$emit('application:route-change', to, from)
                    }, from == undefined ? 0 : 1100)
                }
            }
        },

        pageTransition() {
            if (!this.isFirstLoading) {
                this.routingStep = 1

                setTimeout(() => {
                    this.routingStep = 2

                    this.isMenuOpened = false

                    setTimeout(() => {
                        this.routingStep = 3

                        this.scrollTo(0)

                        setTimeout(() => {
                            this.routingStep = 0
                        }, 1000)
                    }, 1000) // Timeout for transition-duration + transition-delay on .page.was-routed
                }, 1000)
            }
        },

        onRoutingStepChange() {
            this.eventHub.$emit('application:routing-step-change', this.routingStep)
        },

        // JSON
        _getJSON(url) {
            return new Promise((resolve, reject) => {
                Gateway.getInstance().send(
                    'GET',
                    url,
                    {},
                    response => {
                        resolve(response)
                    },
                    error => {
                        reject(error)
                    }
                )
            })
        },

        _catchError(error) {
            this._content = null
            this.content = null
            console.error(error)
        },

        // Meta tags
        _updatePageMeta(route) {
            let seoUrl = `/static/json/seo.json`
            let key = route.meta.seo

            if (route.name === this.CONFIG.pages.homeSlide.name) {
                if (route.params.slug) {
                    key = key.replace(':slug', route.params.slug)
                } else {
                    key = key.replace(':slug', '00')
                }
            }

            Gateway.getInstance().send(
                'GET',
                seoUrl,
                {},
                response => {
                    const seo = response[key] || response.default
                    // Meta
                    document.title = seo.meta.title

                    const descriptionTag = document.querySelector('meta[name=description]')
                    if (descriptionTag && seo.meta.description.trim() !== '') {
                        descriptionTag.setAttribute('content', seo.meta.description)
                    }

                    // Open Graph
                    const ogTitle = document.querySelector('meta[property="og:title"]')
                    const ogSiteName = document.querySelector('meta[property="og:site_name"]')
                    const ogImage = document.querySelector('meta[property="og:image"]')
                    const ogDescription = document.querySelector('meta[property="og:description"]')
                    const ogUrl = document.querySelector('meta[property="og:url"]')

                    if (ogTitle && seo.share.openGraph.title && seo.share.openGraph.title.trim() !== '') {
                        ogTitle.setAttribute('content', seo.share.openGraph.title)
                    }

                    if (ogSiteName && seo.share.openGraph.title && seo.share.openGraph.title.trim() !== '') {
                        ogSiteName.setAttribute('content', seo.share.openGraph.title)
                    }

                    if (ogDescription && seo.share.openGraph.description && seo.share.openGraph.description.trim() !== '') {
                        ogDescription.setAttribute('content', seo.share.openGraph.description)
                    }

                    if (ogImage && seo.share.openGraph.image && seo.share.openGraph.image.trim() !== '') {
                        ogImage.setAttribute('content', window.location.origin + seo.share.openGraph.image)
                    }

                    if (ogUrl) {
                        ogUrl.setAttribute('content', window.location)
                    }

                    // Twitter
                    const twitterTitle = document.querySelector('meta[name="twitter:title"]')
                    const twitterImage = document.querySelector('meta[name="twitter:image"]')
                    const twitterDescription = document.querySelector('meta[name="twitter:description"]')

                    if (twitterTitle && seo.share.twitter.title && seo.share.twitter.title.trim() !== '') {
                        twitterTitle.setAttribute('content', seo.share.twitter.title)
                    }

                    if (twitterDescription && seo.share.twitter.description && seo.share.twitter.description.trim() !== '') {
                        twitterDescription.setAttribute('content', seo.share.twitter.description)
                    }

                    if (twitterImage && seo.share.twitter.image && seo.share.twitter.image.trim() !== '') {
                        twitterImage.setAttribute('content', window.location.origin + seo.share.twitter.image)
                    }
                },
                error => {
                    console.error(error)
                }
            )
        },

        // Cookie
        createCookie(c) {
            const date = c.expire ? c.expire : new Date()
            if (!c.expire) {
                date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000))
            }

            const expires = '; expires=' + date.toUTCString()
            const cookie = `${c.name}=${JSON.stringify(c.value)}${expires}; path=/`

            document.cookie = cookie
        },

        readCookie(name) {
            const nameEQ = `${name}=`
            const decodedCookie = decodeURIComponent(document.cookie)
            const ca = decodedCookie.split(';')
            for (let i = 0; i < ca.length; i+= 1 )
            {
                let c = ca[i]
                while ( c.charAt(0) == ' ' ) c = c.substring( 1, c.length )
                    if ( c.indexOf( nameEQ ) == 0 ) return c.substring( nameEQ.length, c.length )
            }
            return null
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/application/script.js